export const Themes = {
    state: {
        themes: {
            1: { id: 1, pos: 1 },
            2: { id: 2, pos: 2 },
            3: { id: 3, pos: 3 },
            4: { id: 4, pos: 4 }
        }
    },
    mutations: {},
    getters: {
        getThemes(state) {
            return state.themes;
        },
        getThemeDefault(state) {
            let items = Object.keys(state.themes);
            return items[0];
            //return items[Math.floor(Math.random() * items.length)];
        },
        getActiveTheme: (state, getters) => {
            return getters.getProp('tecpage.user.settings.theme');
        }
    }
};
